import { render, staticRenderFns } from "./DashboardWelcomeCategory.vue?vue&type=template&id=4c3a819e&scoped=true&"
import script from "./DashboardWelcomeCategory.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcomeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a819e",
  null
  
)

export default component.exports